// @flow
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import glamorous from "glamorous";
import t from "common/i18n";
import Button from "root/components/Button";
import MenuButton from "root/components/MenuButton/MenuButton";
import SvgIcon from "../SvgIcon";
import { selectNotification } from "../../selectors";
import bindActions, { types as ats } from "../../actions";
import SVG_ICONS from "~/assets/icons/icons";

// type OwnProps = {|
//
// |};

type Props = {
    id: ?string,
    text: ?string,
    type?: "success",
    width: ?number,
    actions?: Array<{
        label: string,
        onClick?: Function,
        color?: string,
        textColor?: string,
    }>,
    [CLEAR_NOTIFICATION: string]: Function
};

const GToast = glamorous.div(cx(
	"Notification",
	"absolute center",
	"left-0 right-0",
	"w-100",
	"z-999",
), {
	top: 52,
});

const GToastInner = glamorous.div(cx(
	"overflow-hidden",
	"ma4",
	"flex items-center justify-between",
	"ba",
	"bg-window bc-window-border bg-window-c",
	"relative",
	"z-1",
), {
	padding: "14px 16px",
	boxShadow: "0 6px 15px rgba(0,0,0,0.24)",
});

const GMessage = glamorous.div(cx("flex items-center", "f5"));

const GClose = glamorous.div(cx("ml4 flex items-center"));

const GToastUnderlay = glamorous.div(
	cx(
		"Notification-underlay",
		"fixed",
		"top-0",
		"right-0",
		"bottom-0",
		"left-0",
	),
	{
		background: "rgba(0, 0, 0, 0.5)",
	},
);

export const Notification = (props: Props) => (props.id && props.text
	? <GToast className={cx(props.width ? `w-${props.width}-ns` : "w-50-ns")}>
		{props.underlay && <GToastUnderlay />}
		{props.id && <GToastInner>
			<GMessage>
				{props.type === "success" && <SvgIcon className="mr3 flex-shrink-0" size="xl2" path={SVG_ICONS.CHECKED} colorName="complete"/>}
				{!props.type && <SvgIcon className="mr3 flex-shrink-0" size="xl2" path={SVG_ICONS.ERROR} colorName="error"/>}
				{props.text && t(props.text)}
			</GMessage>
			<div className="flex items-center">
				{props.actions && props.actions.length && <GClose>
					{props.actions.map((action) => <Button key={action.label}
						onClick={() => {
							if (action.onClick) {
								action.onClick();
							} else {
								props[ats.CLEAR_NOTIFICATION]({ id: props.id });
							}
						}}
						colorName={action.color}
						textColorName={action.textColor}
						text={action.label}
						fontSize={12} />)}
				</GClose>}
				<GClose>
					<MenuButton
						iconSize="sm"
						icon={SVG_ICONS.CLOSE}
						onClick={() => props[ats.CLEAR_NOTIFICATION]({ id: props.id })} />
				</GClose>
			</div>
		</GToastInner>}
	</GToast> : null);

// const selectProps: Function = selectNotification; //flow is so stupid!

// const mapStateToProps = (state) => ({
//     palette: selectPalette(state),
// });

export default connect<Props, *, _, _, _, _>(
	selectNotification,
	bindActions,
)(Notification);
